import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import Input from "../Input";
import MatrixInput from "../testing/MatrixInput";
import { post } from "../../lib/Fetching";

class NewQuoteGroup extends React.Component {
  state = {
    name: "",
    matrix_id: null
  };

  handleNameChange = event => {
    this.setState({ name: event.target.value });
  };

  handleMatrixChange = option => {
    this.setState({ matrix_id: option.value });
  };

  isValid = () => {
    const { fixed_matrix_id } = this.props;
    const { name, matrix_id } = this.state;
    return (fixed_matrix_id && name) || (!fixed_matrix_id && matrix_id && name);
  };

  addGroup = () => {
    if (!this.isValid()) return;

    const { onGroupAdded, fixed_matrix_id, parent_quote_group_id, attempt_id } = this.props;
    const { matrix_id, name } = this.state;
    return post("/quote_groups.json", {
      attempt_id,
      parent_quote_group_id,
      name,
      matrix_id
    })
      .then(json => onGroupAdded(json.id))
      .catch(e => alert("Could not add quote group: " + e.message));
  };

  render() {
    const { onCancel, fixed_matrix_id } = this.props;
    const { name } = this.state;
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <div className="form-inline" style={{ textAlign: "center" }}>
            <div className="form-group">
              <Input
                id="new_group_name"
                onPressEnter={this.addGroup}
                onPressEscape={onCancel}
                autoFocus
                className="form-control"
                placeholder="Add new group name..."
                type="text"
                value={name}
                style={{ width: 250 }}
                onChange={this.handleNameChange}
              />
            </div>
            {!fixed_matrix_id && (
              <div className="form-group" style={{ marginLeft: 20 }}>
                <MatrixInput onChange={this.handleMatrixChange} multiple={false} />
              </div>
            )}
            <div className="form-group" style={{ marginLeft: 20 }}>
              <Button
                title="Add Group"
                disabled={!this.isValid()}
                onClick={this.addGroup}
                primary
              />
            </div>
            <div className="form-group" style={{ marginLeft: 20 }}>
              <Button title="Cancel" onClick={onCancel} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewQuoteGroup;
